import React from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Body1,
  Button,
  Display5,
  majorScale,
  Pane
} from '@segment/react-ui-library'

const ErrorMessage = props => {
  const { title, messaging, primaryButton } = props

  if (!primaryButton.onClick) {
    primaryButton.onClick = () => window.location.reload()
  }

  return (
    <Pane flex="1">
      <Alert type="danger" marginX="auto" marginY={majorScale(8)}>
        <Display5>{title}</Display5>
        {messaging && <Body1>{messaging}</Body1>}
        {primaryButton && (
          <Button
            primary
            marginTop={majorScale(1)}
            onClick={(...args) => primaryButton.onClick(props, ...args)}
          >
            {primaryButton.children}
          </Button>
        )}
      </Alert>
    </Pane>
  )
}

ErrorMessage.defaultProps = {
  primaryButton: {}
}

ErrorMessage.propTypes = {
  title: PropTypes.string.isRequired,
  messaging: PropTypes.node,
  primaryButton: PropTypes.shape({
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired
  })
}

export default ErrorMessage
